module.exports = __webpack_public_path__ + "media/exports/required/assets/img/images/brand_white-3a0dba6b8ddf54414cb1e0485f53172b.png";